module.exports = __webpack_public_path__ + "static/mentor-ankit-f706bc2722c3d77ad5b4eda79413eed2.jpg";